// extracted by mini-css-extract-plugin
export var buttons = "_ae-0";
export var buttonsActive = "_ae-h";
export var cancelConfirm = "_ae-1";
export var closeButton = "_ae-2";
export var column = "_ae-3";
export var container = "_ae-4";
export var detailHeader = "_ae-6";
export var detailTitle = "_ae-7";
export var detailsContent = "_ae-5";
export var header = "_ae-8";
export var headerWithClose = "_ae-9";
export var icon = "_ae-a";
export var infoIcon = "_ae-c";
export var informationContainer = "_ae-b";
export var sideDrawer = "_ae-d";
export var sideDrawerOpen = "_ae-e";
export var stickyFooter = "_ae-f";
export var typeOption = "_ae-g";